import React from 'react';
export const UnknownId = () => (
  <svg width="157px" height="101px" viewBox="0 0 157 101" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1524.000000, -1902.000000)">
        <g transform="translate(1524.000000, 1902.000000)">
          <path
            d="M156.2466,95.9965 L124.5016,95.9965"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M48.5,95.9965 L18.6596,95.9965"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.6592,95.9965 L0.6232,95.9965"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.0611,96.1069 C100.0611,98.4169 92.3931,100.2889 82.9351,100.2889 C73.4761,100.2889 65.8091,98.4169 65.8091,96.1069 C65.8091,93.7969 73.4761,91.9249 82.9351,91.9249 C92.3931,91.9249 100.0611,93.7969 100.0611,96.1069"
            fill="#D0D7DA"
          />
          <g
            transform="translate(26.000000, 10.000000)"
            stroke="#AA81F7"
            strokeLinecap="round"
          >
            <path d="M3.7027,0.8012 L3.7027,2.5512" />
            <path d="M3.7027,6.0512 L3.7027,7.8012" />
            <path d="M7.2027,4.3012 L5.4527,4.3012" />
            <path d="M1.9527,4.3012 L0.2027,4.3012" />
          </g>
          <path
            d="M141.036,50.518 C141.036,51.356 140.356,52.036 139.518,52.036 C138.68,52.036 138,51.356 138,50.518 C138,49.68 138.68,49 139.518,49 C140.356,49 141.036,49.68 141.036,50.518"
            fill="#CCD82B"
          />
          <path
            d="M22.036,49.518 C22.036,50.357 21.356,51.037 20.518,51.037 C19.68,51.037 19,50.357 19,49.518 C19,48.68 19.68,48 20.518,48 C21.356,48 22.036,48.68 22.036,49.518"
            fill="#F5C400"
          />
          <g transform="translate(51.000000, 30.000000)">
            <path
              d="M2.9346,7.933 L3.4426,2.784 C3.5886,1.304 4.9066,0.223 6.3856,0.37 L62.8936,5.946 C64.3726,6.091 65.4546,7.41 65.3086,8.888 L62.1336,41.054 C61.9876,42.534 60.6696,43.615 59.1906,43.468 L2.6826,37.892 C1.2036,37.745 0.1226,36.428 0.2686,34.949 L2.3926,13.416"
              fill="#FFFFFF"
            />
            <path
              d="M5.56619589,7.933 L6.05276761,2.784 C6.19260908,1.304 7.45501365,0.223 8.87162697,0.37 L62.9960255,5.946 C64.4126388,6.091 65.4489982,7.41 65.3091567,8.888 L62.2680835,41.054 C62.1282421,42.534 60.8658375,43.615 59.4492242,43.468 L5.32482567,37.892 C3.90821235,37.745 2.87281073,36.428 3.01265221,34.949 L5.04705835,13.416"
              stroke="#AA81F7"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="3,6"
            />
          </g>
          <path
            d="M106.12515,34.8397566 L86.4955589,17.125722 L48.6251505,17.125722 C46.6921539,17.125722 45.1251505,18.6927254 45.1251505,20.625722 L45.1251505,52.625722 C45.1251505,54.5587186 46.6921539,56.125722 48.6251505,56.125722 L102.62515,56.125722 C104.558147,56.125722 106.12515,54.5587186 106.12515,52.625722 L106.12515,34.8397566 Z"
            stroke="#7350A0"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(75.625150, 36.625722) rotate(-5.000000) translate(-75.625150, -36.625722) "
          />
          <path
            d="M68.7701,40.975 C69.4911,39.637 69.8471,38.074 69.7121,36.435 C69.3491,31.997 65.5291,28.69 61.1801,29.046 C56.8321,29.403 53.6011,33.288 53.9651,37.726 C54.0991,39.365 54.7051,40.849 55.6341,42.051"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M64.5401,33.3871 C64.5401,33.3871 65.2791,34.4231 65.2121,36.9321 C65.2121,36.9321 65.2901,39.1791 63.7631,40.5771 L67.8571,42.0101 L67.7181,42.1711 C66.4171,43.6371 64.5741,44.6211 62.4701,44.7941 C60.3671,44.9661 58.3881,44.2951 56.8661,43.0611 L56.7031,42.9251 L57.5611,42.4551 L60.5081,40.8441 C58.7741,39.7121 58.5121,37.4811 58.5121,37.4811 C58.0371,35.0161 58.5711,33.8761 58.5711,33.8761 C58.5711,33.8761 59.2511,32.1771 61.4221,31.9991 C63.5921,31.8221 64.5401,33.3871 64.5401,33.3871 Z"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.505538,33.8168 L77.3303726,35.7868 C76.8034484,35.8358 76.3370196,35.3838 76.2949358,34.7838 C76.2519752,34.1828 76.6473876,33.6508 77.1734351,33.6018 L98.3494773,31.6318 C98.8755248,31.5838 99.3419536,32.0348 99.3849141,32.6348 C99.4278747,33.2358 99.0324623,33.7678 98.505538,33.8168"
            fill="#DDE5E8"
          />
          <path
            d="M98.0046531,28.2172 L76.8294877,30.1872 C76.3034402,30.2362 75.8370114,29.7842 75.7940509,29.1842 C75.7510903,28.5832 76.1465027,28.0512 76.673427,28.0022 L97.8485924,26.0322 C98.3755166,25.9842 98.8410687,26.4352 98.8840292,27.0352 C98.9269898,27.6362 98.5315774,28.1672 98.0046531,28.2172"
            fill="#DDE5E8"
          />
          <path
            d="M77.8082,46.2289 C78.9512,46.0199 79.8622,45.1859 80.7052,44.3879 C82.1512,43.0199 83.5972,41.6519 85.0422,40.2849 C84.5052,41.8549 83.9672,43.4249 83.4292,44.9959 C84.2872,45.1099 85.0712,44.5259 85.7042,43.9349 C86.3372,43.3439 86.9982,42.6779 87.8572,42.5649 C88.7152,42.4529 89.7042,43.2979 89.3502,44.0879 C89.8102,45.0529 89.3732,46.3459 88.4232,46.8349 C88.3792,45.5669 89.1382,44.3669 90.1612,43.6149 C91.1832,42.8629 92.4402,42.4989 93.6892,42.2729 C94.4592,42.1329 95.3182,42.0589 95.9662,42.4989 C96.6132,42.9389 96.7642,44.0919 96.0632,44.4409 C97.7422,43.2409 99.8632,42.6749 101.9172,42.8809"
            stroke="#D62793"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.3443,53.3461 L105.0503,51.4861 C105.9233,51.4141 106.5723,50.6491 106.5003,49.7771 L106.0883,44.7471"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M75.3585,53.9184 L79.1335,53.6084"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g
            transform="translate(96.000000, 7.000000)"
            fillRule="nonzero"
            stroke="#0B9CE5"
          >
            <circle />
            <g transform="translate(5.000000, 4.000000)" fill="#FFFFFF">
              <path d="M3.62488038,8.49361373 C2.97283414,8.55990746 2.3792434,8.10364543 2.30669752,7.4563469 C2.30560297,7.4459825 2.30560297,7.4459825 2.30438215,7.43333209 C2.30403488,7.42949784 2.30403488,7.42949784 2.30370393,7.42562616 C2.30225468,7.40709264 2.30225468,7.40709264 2.3003615,7.37905159 C2.24145263,6.37140264 2.72730765,5.30975329 3.74198937,4.41376146 C3.96493188,4.21689709 4.21133538,4.03171008 4.48104901,3.85841529 C4.97583321,3.54061185 5.1,3.34639688 5.1,2.96812764 C5.1,2.38113804 4.40812731,1.83332412 3.5,1.83332412 C2.56157873,1.83332412 1.9,2.33177032 1.9,2.88886893 C1.9,3.53880307 1.35743193,4.05553099 0.7,4.05553099 C0.0425680713,4.05553099 -0.5,3.53880307 -0.5,2.88886893 C-0.5,0.954146072 1.29013675,-0.5 3.5,-0.5 C5.68643548,-0.5 7.5,1.02330727 7.5,2.96812764 C7.5,4.16410968 6.95066308,5.06889435 5.8044326,5.8051264 C5.63630508,5.9131507 5.48689891,6.02527799 5.35576234,6.14107518 C5.04804149,6.41280115 4.85350831,6.6896779 4.755997,6.96847461 C4.71122218,7.09649128 4.69382534,7.20095382 4.69476602,7.22503808 C4.75991982,7.86412577 4.27455807,8.42756082 3.62488038,8.49361373 Z M4.69478807,7.22491468 L4.69349532,7.21208578 L4.19604499,7.26251559 L3.6991569,7.31821328 L3.69931949,7.31973403 L3.69929887,7.31974541 L4.19718069,7.27377053 L4.69478807,7.22491468 Z" />
              <path d="M2.59700155,9.50032189 C2.86168805,8.7298615 3.70613709,8.31886907 4.48342021,8.57696681 C5.26448638,8.83632073 5.68650847,9.67442547 5.42049921,10.4487362 L5.40299845,10.4996781 C5.13831195,11.2701385 4.29386291,11.6811309 3.51657979,11.4230332 C2.73551362,11.1636793 2.31349153,10.3255745 2.57950079,9.55126381 L2.59700155,9.50032189 Z" />
            </g>
          </g>
          <g
            transform="translate(85.000000, 0.000000)"
            stroke="#FE5E48"
            strokeLinecap="round"
          >
            <path d="M4.187,10.3872 L0,10.3302" />
            <path d="M9.832,4.187 L9.889,0" />
            <path d="M5.7622,5.6821 L2.7812,2.5401" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
